import React, { Component } from 'react';
import { Radio } from 'antd';

export default class RadioBtnGroup extends Component {    
    onChange = (e) => {
        this.props.onChange(e.target.value);
    };

    render() {
        const btns = this.props.btns || [];
        const defaultValue = this.props.defaultValue;

        return (
            <div>
                <Radio.Group 
                // size="large"
                style={{marginTop: 18}}
                value={defaultValue} 
                buttonStyle="solid"
                onChange={this.onChange}> 
                    {btns.map(item => {
                        return <Radio.Button key={item.key} value={item.key}>{item.val}</Radio.Button>
                    })}
                </Radio.Group>
            </div>
        );
    }
}